import { useEffect, useState } from "react";
import { Trash2, Upload } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fileUrl } from "../../lib/api";
import { Card } from "../dash/Shell";

export default function AdminGallery() {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/admin/gallery").then(({ data }) => setRows(data));
  useEffect(() => { load().catch((e) => toast.error(errMsg(e))); }, []);

  const upload = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setBusy(true);
    try {
      for (const f of files) {
        const fd = new FormData(); fd.append("file", f);
        await api.post("/files/upload?kind=gallery", fd);
      }
      await load(); toast.success(`${files.length} photo(s) uploaded`);
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); e.target.value = ""; }
  };

  const remove = async (id) => { try { await api.delete(`/admin/gallery/${id}`); await load(); } catch (err) { toast.error(errMsg(err)); } };

  return (
    <Card title="Work photos" sub="Upload real before/after photos — they appear first in the website gallery." testid="admin-gallery">
      <label className={`flex items-center justify-center gap-3 rounded-2xl border border-dashed border-gold/40 bg-gold/5 px-5 py-8 cursor-pointer hover:border-gold ${busy ? "opacity-50" : ""}`}>
        <Upload size={18} className="text-gold" />
        <span className="text-sm text-slate-200">{busy ? "Uploading…" : "Click to upload JPG / PNG / WEBP (max 8 MB each)"}</span>
        <input data-testid="gallery-upload-input" type="file" accept="image/*" multiple className="hidden" disabled={busy} onChange={upload} />
      </label>
      {rows.length > 0 && (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 mt-6">
          {rows.map((f) => (
            <figure key={f.id} data-testid={`gallery-admin-item-${f.id}`} className="group relative aspect-square overflow-hidden rounded-2xl border border-white/10">
              <img src={fileUrl(f.id)} alt="" className="w-full h-full object-cover" />
              <button data-testid={`gallery-delete-${f.id}`} onClick={() => remove(f.id)} className="absolute top-2 right-2 rounded-full bg-ink/80 p-2 text-slate-300 hover:text-red-300 opacity-0 group-hover:opacity-100 transition-opacity"><Trash2 size={14} /></button>
            </figure>
          ))}
        </div>
      )}
    </Card>
  );
}
